var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "custom-page archives-page"
  }, [_c('div', {
    staticClass: "theme-vdoing-wrapper"
  }, [_c('h1', [(_vm.$themeConfig.titleBadge === false ? false : true) ? _c('img', {
    attrs: {
      "src": _vm.currentBadge
    }
  }) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.$page.title) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "count"
  }, [_vm._v("\n      总共 "), _c('i', [_vm._v(_vm._s(_vm.$sortPostsByDate.length))]), _vm._v(" 篇文章\n    ")]), _vm._v(" "), _c('ul', [_vm._l(_vm.postsList, function (item, index) {
    return [(_vm.year = _vm.getYear(index)) !== _vm.getYear(index - 1) ? _c('li', {
      key: index + _vm.$sortPostsByDate.length,
      staticClass: "year"
    }, [_c('h2', [_vm._v("\n            " + _vm._s(_vm.year) + "\n            "), _c('span', [_c('i', [_vm._v(_vm._s(_vm.countByYear[_vm.year]))]), _vm._v(" 篇\n            ")])])]) : _vm._e(), _vm._v(" "), _c('li', {
      key: index
    }, [_c('router-link', {
      attrs: {
        "to": item.path
      }
    }, [_c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm.getDate(item)))]), _vm._v("\n            " + _vm._s(item.title) + "\n            "), item.frontmatter.titleTag ? _c('span', {
      staticClass: "title-tag"
    }, [_vm._v("\n              " + _vm._s(item.frontmatter.titleTag) + "\n            ")]) : _vm._e()])], 1)];
  })], 2)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };